import React, { useState } from 'react'
import { sanitizeHTML } from '../../../../utils/common-utils'
import { Card } from '../Card/Card'
import { CardGridProps } from './CardGrid.type'

export const CardGrid = (props: CardGridProps) => {
  const {
    componentSpacing,
    cardLimit,
    cardList,
    cardGridHeadline,
    cardDescription,
    button,
    brandExtension,
  } = props

  const numberOfCardsToShow = cardLimit ? Number(cardLimit) : cardList?.length

  const [showLoadMore, setShowLoadMore] = useState(
    numberOfCardsToShow && cardList && numberOfCardsToShow < cardList?.length
  )

  const buildButton = () => {
    if (!button) {
      return null
    }
    const { linkHref, linkTarget, analytics, linkText, linkAltText } = button
    return (
      <a
        className='Button Button--secondary Button--secondary--action-blue Button--small'
        href={linkHref}
        target={linkTarget}
        aria-label={linkAltText || ''}
        data-testid='card-grid-button'
        data-analytics={analytics ?? ''}
      >
        {linkText}
      </a>
    )
  }

  if (!cardList) {
    return null
  }

  const hasDates = cardList.every(card => card.cardContent?.rawDate)

  let sortedByTime = null
  if (hasDates) {
    sortedByTime = cardList.sort(
      (card1, card2) => Number(card2.cardContent?.rawDate) - Number(card1.cardContent?.rawDate)
    )
  }

  return (
    <section
      className={`card-grid-component ${componentSpacing} ${brandExtension}`}
      data-limit={cardLimit}
    >
      <div
        className='u-sizeConstrained u-sm-flexCol u-sm-flexJustifyCenter'
        data-testid={props.testId ?? null}
      >
        <div className='u-flex u-flexJustifyBetween'>
          {cardGridHeadline && (
            <h2 className='u-textColorDefault u-marginBottom16'>{cardGridHeadline}</h2>
          )}
          {button && <div className='Button--customSmallHidden'>{buildButton()}</div>}
        </div>
        {cardDescription && (
          <div
            className='card-description Content u-marginBottom20'
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(cardDescription) }}
          />
        )}
        <div className='card-list-wrapper u-sm-flex u-sm-flexCol u-marginBottom20'>
          {hasDates &&
            sortedByTime
              ?.slice(0, showLoadMore ? numberOfCardsToShow : sortedByTime.length)
              .map(card => <Card key={card.cardId} card={card} />)}
          {!hasDates &&
            cardList
              .slice(0, showLoadMore ? numberOfCardsToShow : cardList.length)
              .map(card => <Card key={card.cardId} card={card} />)}
        </div>
        <div className='u-flex u-flexJustifyCenter Button--customSmallShow u-md-hidden u-lg-hidden'>
          {buildButton()}
        </div>
      </div>
      {showLoadMore && (
        <div className='u-sizeConstrained u-flex u-flexJustifyCenter u-sm-marginTop24 u-md-marginTop24'>
          <button
            className='Button Button--secondary Button--secondary--action-blue Button--small'
            onClick={() => setShowLoadMore(false)}
          >
            Load more
          </button>
        </div>
      )}
    </section>
  )
}
